import { getCachedRequest } from '../../utils/request/methods.js';
import { removeOldBoatFilters } from '../../utils/parsers/boat/filters.js';

function listMarkers(params, init) {
    return getCachedRequest(`${process.env.API_SEARCH_URI}/v1/map/markers`, removeOldBoatFilters(params), init);
}
function getMarker(slug, init) {
    return getCachedRequest(`${process.env.API_URI}/v1/map/markers/${slug}/`, null, init);
}
async function listAllMarkers(params, init) {
    if (params == null) {
        const res = await import('./all.json.js');
        return res.default;
    }
    return listMarkers(params, init);
}

export { getMarker, listAllMarkers, listMarkers };
//# sourceMappingURL=markers.js.map
